import React from 'react';
import { TreeMap } from '@carbon/pictograms-react';

export const NoDataDisplay: React.FC<{}> = () => {
  return (
    <div className="no-data--wrapper">
      <TreeMap />
      <h2 className="no-data--header-text">There is no report to display</h2>
      <p className="no-data--body-text">
        First select a report type and filters, then generate your report
      </p>
    </div>
  );
};

export default NoDataDisplay;
